import type { Address } from '@/models/address';
import type { PreCadastroAdmissao } from '../models/preCadastroAdmissao.types';

/** Chaves das respostas do Pré-cadastro — o texto da pergunta muda conforme a origem
 * (Etapa 2 do Recrutamento x Forms antigo do SharePoint; ver PreCadastroAdmissaoSection). */
export const CHAVES_CPF_PRE_CADASTRO = ['CPF', 'CPF:'];
export const CHAVES_ENDERECO_PRE_CADASTRO = [
  'Endereço completo',
  'Endereço Completo: Informar Rua, número, complemento, bairro, cidade, UF, CEP e complemento se tiver',
];
export const CHAVES_TELEFONE_PRE_CADASTRO = ['Telefone para contato', 'Telefone para contato Informar DDD'];

export function respostaPreCadastro(preCadastro: PreCadastroAdmissao | null | undefined, chaves: string[]): string | null {
  return chaves.map((chave) => preCadastro?.respostas[chave]).find(Boolean) ?? null;
}

/** Correspondência primeiro (é pra onde os Correios entregam), senão o principal. */
export function enderecoParaEntrega(enderecos: Address[] | null | undefined): Address | null {
  if (!enderecos?.length) return null;
  return enderecos.find((e) => e.type === 'mailing') ?? enderecos.find((e) => e.type === 'main') ?? enderecos[0];
}

/** "Rua X, 123, Apto 4 - Bairro, Cidade/UF - CEP 00000-000" — cai no `fullAddress` quando
 * o endereço não tem os campos separados (cadastros antigos/importados). */
export function formatarEndereco(endereco: Address | null): string | null {
  if (!endereco) return null;
  const rua = [endereco.street, endereco.number, endereco.complement].filter(Boolean).join(', ');
  const cidadeUf = [endereco.city, endereco.state].filter(Boolean).join('/');
  const partes = [
    rua,
    [endereco.neighborhood, cidadeUf].filter(Boolean).join(', '),
    endereco.zipCode ? `CEP ${endereco.zipCode}` : null,
  ].filter(Boolean);
  return partes.length > 0 ? partes.join(' - ') : endereco.fullAddress || null;
}
